<app-manage-template [title]="'Contacts of Business Listing'" [FIELDS]="fields" [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'BUSINESS_CONTACTS_LISTING'"
(updateParent)="updateBusinessNetwork($event)"
(updateMembers)="updateBusinessNetworkMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll"></app-manage-template>
